<app-header></app-header>
<div class="wrapper">
  <div class="search-page">
    <!-- inner-heading-section -->
    <section class="">
      <div class="container">
        <div class="search-form">
          <div class="section-head head-pr-0 text-center d-sm-block d-none">
            <h1>{{ "SEARCH.MESSAGE" | translate }}</h1>
          </div>
          <form
            name="form"
            (ngSubmit)="f.form.valid && search('newSearch')"
            #f="ngForm"
            novalidate
          >
            <div class="form-group mb-0" [ngClass]="{ active: searchBox }">
              <span class="icon-search"></span>
              <input
                #searchFocus
                type="text"
                name="search_value"
                class="form-control"
                (keypress)="onKey()"
                [(ngModel)]="model.search_value"
                placeholder="{{ 'SEARCH.PLACEHOLDER_SEARCH' | translate }}"
                matInput
                [formControl]="myControl"
                [matAutocomplete]="auto"
                (ngModelChange)="getSuggationData($event)"
                required
              />
              <mat-autocomplete
                (opened)="isOpened()"
                (closed)="isClosed()"
                (optionSelected)="getSearchData($event.option.value)"
                #auto="matAutocomplete"
                [displayWith]="showValue"
                class="search-box"
              >
                <div class="scroll-box" *ngIf="model.search_value.length > 0">
                  <div>
                    <div class="search-box-head list-head">
                      {{ "HEADER.VIDEOS" | translate }}
                    </div>
                    <div class="search-list">
                      <div *ngIf="moviesData.length > 0 && !moviesSpinner">
                        <div *ngFor="let option of moviesData; let i = index">
                          <mat-option [value]="option">
                            <span class="mdi mdi-play-circle-outline"></span>
                            {{ option?.text }}
                          </mat-option>
                          <span
                            *ngIf="option?.is_deleted == 'yes'"
                            (click)="removeText(i, option['_id'], $event)"
                            class="remove-link"
                            >{{ "SEARCH.REMOVE" | translate }}</span
                          >
                        </div>
                      </div>

                      <div *ngIf="moviesData.length === 0 && !moviesSpinner">
                        <mat-option> No Results </mat-option>
                      </div>
                      <div *ngIf="moviesSpinner">
                        <mat-option> <mat-spinner></mat-spinner> </mat-option>
                      </div>
                    </div>
                  </div>
                  <!-- <div>
                    <div class="search-box-head list-head">
                      {{ "HEADER.SHOWS" | translate }}
                    </div>
                    <div class="search-list">
                      <div *ngFor="let option of seriesData; let i = index">
                        <mat-option [value]="option">
                          <span class="mdi mdi-play-circle-outline"></span>
                          {{ option?.text }}
                        </mat-option>
                        <span
                          *ngIf="option?.is_deleted == 'yes'"
                          (click)="removeText(i, option['_id'], $event)"
                          class="remove-link"
                          >{{ "SEARCH.REMOVE" | translate }}</span
                        >
                      </div>
                      <div *ngIf="seriesData.length === 0">
                        <mat-option> No Results </mat-option>
                      </div>
                    </div>
                  </div> -->
                  <!-- <div>
                    <div class="search-box-head list-head">{{ "HEADER.MUSIC" | translate }}</div>
                    <div
                      class="search-list"
                      *ngFor="let option of albumData; let i = index"
                    >
                      <mat-option [value]="option">
                        {{ option?.text }}
                      </mat-option>
                      <span
                        *ngIf="option?.is_deleted == 'yes'"
                        (click)="removeText(i, option['_id'], $event)"
                        class="remove-link"
                        >{{ "SEARCH.REMOVE" | translate }}</span
                      >
                    </div>
                    <mat-option *ngIf="albumData.length === 0">
                      No Results
                    </mat-option>
                  </div> -->
                </div>
              </mat-autocomplete>
              <button class="btn-search" *ngIf="!searchStatus">
                <span class="icon-arrow-back"></span>
              </button>
              <button
                (click)="resetSearch()"
                type="button"
                class="btn-search"
                *ngIf="searchStatus"
              >
                <span class="icon-close"></span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>

    <section class="related-search" *ngIf="recentdata.length > 0 && isSearch">
      <div class="container">
        <div class="">
          <div class="section-head row pl-1">
            <h2>{{ "SEARCH.RECENT_SEARCHES" | translate }}</h2>
          </div>
        </div>
        <div class="row custome-set">
          <div class="series-box" *ngFor="let data of recentdata">
            <app-grid [data]="data" [gridType]="'landscape'"></app-grid>
          </div>
        </div>
      </div>
    </section>
    <div
      infiniteScroll
      [infiniteScrollDistance]="1"
      [infiniteScrollThrottle]="150"
      (scrolled)="onScroll()"
    >
      <section class="related-search" *ngIf="isSearch">
        <div class="container">
          <div class="" *ngIf="searchContent.length > 0">
            <div class="section-head row pl-3">
              <h2 class="mb-0">{{ "SEARCH.SEARCH_RESULT" | translate }}</h2>
            </div>
          </div>
          <div
            class="record-not-available"
            style="min-height: auto"
            *ngIf="searchContent.length == 0 && shimmerStatus.search == false"
          >
            <div class="text-center">
              <img src="assets/images/no-recoard-playlist.png" />
              <p class="no-recored-content text-secondary">
                {{ "RECORD_NOT_FOUND_SEARCH" | translate }}
                <a
                  href="javascript:void(0)"
                  class="font-bold orange-link"
                  [routerLink]="['/']"
                  >{{ "SEARCH.REDIRECT_HOME" | translate }}</a
                >.
              </p>
            </div>
          </div>
          <div class="row custome-set" *ngIf="searchContent.length > 0">
            <div
              class="series-box"
              *ngFor="let search_data of searchContent"
              (click)="recentSearch(search_data)"
            >
              <app-grid
                [data]="search_data"
                [gridType]="'landscape'"
              ></app-grid>
            </div>
          </div>
        </div>
        <app-grid-simmer
          [shimmerType]="'search'"
          *ngIf="shimmerStatus.search"
        ></app-grid-simmer>
      </section>
    </div>
    <app-grid-simmer
      class="search-page"
      *ngIf="shimmerStatus.genere"
    ></app-grid-simmer>
    <section class="related-search" *ngIf="!shimmerStatus.genere">
      <div class="container" *ngIf="!isSearch">
        <div class="">
          <!-- <div class="section-head">
            <h2>{{ "SEARCH.EXPLORE_BY_GENERES" | translate }}</h2>
          </div> -->
        </div>
        <div class="row custome-set">
          <div
            *ngFor="let genere of genereContent"
            class="series-box genere-series-box"
          >
            <div routerLink="/genere-list/{{ genere.slug }}/movies">
              <div class="ratio-slider ratio-16-9 genere-box">
                <img
                  [src]="genere.image"
                  [src-fallback]="appConstants.genreDefault"
                />
                <div class="h3-absolute">
                  <div class="w-100">
                    <h3>{{ genere | languageTranslate }}</h3>
                    <!-- <div class="sub-content">
                      <div class="title-content">
                        <h2>
                          {{ genere.total_courses }}
                        </h2>
                        <p class="mb-0">
                          {{ "HEADER.SHOWS" | translate }}
                        </p>
                      </div>
                      <div class="title-content">
                        <h2>
                          {{ genere.total_contents }}
                        </h2>
                        <p class="mb-0">
                          {{ "HEADER.VIDEOS" | translate }}
                        </p>
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- <app-language-grid [isSearch]="isSearch"></app-language-grid> -->
  </div>
</div>
<app-footer></app-footer>
